export default "__VITE_PUBLIC_ASSET__0d65840b__"